<template>
  <aside class="alert-box box --sm +text-center +bg-gray-lightest">
    <div class="media --xxs --align-middle +display-inline-flex">
      <figure
        class="media__figure icon --sm +mg-bottom-none"
        :class="isSaved ? '+fill-blue' : '+fill-gray-dark'"
      >
        <bookmark-icon :isSaved="isSaved"></bookmark-icon>
      </figure>
      <h2 class="heading-secondary +heading-zeta +mg-bottom-none">
        {{ alertMessaging }}
      </h2>
    </div>
  </aside>
</template>

<script>
import bookmarkIcon from '../bankrate-onboarding/assets/svg/bookmark-icon.vue'

const COPY_MAP = {
  article: {
    saved: 'Article saved',
    removed: 'Removed from saved items'
  },
  calculator: {
    saved: 'Result saved',
    removed: 'Removed from saved items'
  }
}

export default {
  name: 'alert-box',

  props: {
    isSaved: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'article'
    }
  },

  computed: {
    alertMessaging() {
      return this.isSaved
        ? COPY_MAP[this.type].saved
        : COPY_MAP[this.type].removed
    }
  },

  components: {
    bookmarkIcon
  }
}
</script>

<style scoped lang="scss">
.alert-box {
  border-radius: 7px;
  box-shadow: 0 3.5px 14px 3.5px rgba(0, 0, 0, 0.25);
  left: 14px;
  position: fixed;
  top: -250px;
  transition: all 0.25s ease-in;
  width: calc(100vw - 28px);
  z-index: 30;

  &.\--is-active {
    top: 14px;
  }

  @media (min-width: 47.4375em) {
    left: auto;
    min-width: 12rem;
    right: -500px;
    top: 14px;
    width: auto;

    &.\--is-active {
      right: 14px;
    }
  }
}
</style>
